window.CK = {}; window.CK.config = {
    "exports": {},
    "SVG_DATA_URL_PREFIX_LENGTH": 36,
    "CK_HASH_IDENTIFIER": ".ckh.",
    "environment": {
        "domain": "codekingdoms.com",
        "campDomainBase": ".camps-test.codekingdoms.com",
        "name": "test",
        "servers": {
            "users": {
                "host": "service-test.codekingdoms.com",
                "protocol": "https",
                "port": 443,
                "projectPath": "users",
                "path": "/users"
            },
            "monitor": {
                "host": "service-test.codekingdoms.com",
                "protocol": "https",
                "port": 443,
                "projectPath": "monitor",
                "path": "/monitor"
            },
            "roblox": {
                "host": "service-test.codekingdoms.com",
                "protocol": "https",
                "port": 443,
                "projectPath": "roblox/server",
                "path": "/roblox"
            },
            "sentinel": {
                "projectPath": "minecraft/sentinel"
            },
            "minecraftProxy-us": {
                "host": "minecraft-proxy-test-us.codekingdoms.com",
                "protocol": "https",
                "port": 443,
                "projectPath": "minecraft/proxy",
                "path": ""
            },
            "minecraftProxy-eu": {
                "host": "minecraft-proxy-test-eu.codekingdoms.com",
                "protocol": "https",
                "port": 443,
                "projectPath": "minecraft/proxy",
                "path": ""
            },
            "minecraftProxy-ap": {
                "host": "minecraft-proxy-test-ap.codekingdoms.com",
                "protocol": "https",
                "port": 443,
                "projectPath": "minecraft/proxy",
                "path": ""
            },
            "logstash": {
                "protocol": "https",
                "host": "service-production.codekingdoms.com",
                "port": 443,
                "path": "/logstash"
            }
        },
        "clients": {
            "status": {
                "address": "https://status-test.codekingdoms.com/"
            },
            "website": {
                "address": "https://website-test.codekingdoms.com/"
            },
            "minecraftSequencer": {
                "address": "https://modding-test.codekingdoms.com/"
            },
            "robloxSequencer": {
                "address": "https://roblox-test.codekingdoms.com/"
            },
            "camps": {
                "address": "https://camps-test.codekingdoms.com"
            },
            "coolmath": {
                "address": "https://test.coolmathcoding.com/"
            }
        },
        "STRIPE_PUBLISHABLE_KEY": "pk_test_rUrQ5b9SDLDksnHO8OLGI1iu00xx0tg1gy",
        "GOOGLE_SIGNON_CLIENT_ID": "235413453006-b17mem8riu3h7q59ho2tu6eqcm8jqgjj.apps.googleusercontent.com",
        "FACEBOOK_SIGNON_APP_ID": "1284078488341767"
    },
    "name": "ck-website",
    "release": "1396-71989aae9a",
    "rootDirectory": "/",
    "graphics": {
        "spritesJSON": "graphics/sprites.ckh.c8cf389.json",
        "spritesheets": []
    },
    "builtCss": [
        "/ck.css"
    ],
    "audio": {}
};